export default __webpack_public_path__ + "static/media/horizontal_divider.6e0920be.svg";